import { generatePath, useHistory } from 'react-router';
import {
  urlStructureAdminCenter,
  urlStructureAdminCenterFormEditor
} from '../../../routing/routingPaths';
import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { useCallback } from 'react';

export const useOpenFormEditor = (formType: string, formId?: string) => {
  const history = useHistory();
  const [workspaceId] = useCurrentWorkspace();
  const path = generatePath(urlStructureAdminCenterFormEditor, {
    workspaceId,
    formType,
    formId
  });

  const onOpenFormEditor = useCallback(
    (state) => () => {
      history.push(path, state);
    },
    [history, path]
  );

  const backToFormsView = useCallback(() => {
    const path = generatePath(urlStructureAdminCenter, {
      workspaceId: workspaceId,
      subroute: 'forms'
    });
    // clear the location state
    history.push(path, {});
  }, []);

  return { onOpenFormEditor, backToFormsView };
};
